import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, Button } from '@mui/material';
import image1 from './New_Feature_march_1st.jpg';
import image2 from './Hiring_Poster_18th_Feb.jpg';
import image3 from './January_26th.png';

const Blog = () => {
  const { blogId } = useParams();

  // Sample blog data with unique IDs
  const blogData = [
    {
      id: '1',
      title: "Breaking News: Example Topic",
      image: image1,
      content: "This is the content of the blog about breaking news. Lorem ipsum dolor sit amet...",
      date: "February 19, 2025",
    },
    {
      id: '2',
      title: "Tech News: Example Topic",
      image: image2,
      content: "This blog talks about technology news. Curabitur ac ipsum auctor, volutpat risus in...",
      date: "February 18, 2025",
    },
    {
      id: '3',
      title: "Sports News: Example Topic",
      image: image3,
      content: "Here is a blog post on sports news. Nunc laoreet mi vel orci euismod, non tincidunt purus...",
      date: "February 17, 2025",
    }
  ];

  // Find the blog post that matches the current blogId
  const currentBlog = blogData.find(blog => blog.id === blogId);

  // If no blog is found with the provided blogId
  if (!currentBlog) {
    return (
      <Container>
        <Typography variant="h4" color="error">
          Blog not found
        </Typography>
      </Container>
    );
  }

  return (
    <Container>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img 
          src={currentBlog.image} 
          alt={currentBlog.title} 
          style={{ 
            width: '100%', // Ensure the image spans the full width of the container
            height: 'auto', // Adjust the height based on the image's aspect ratio
            objectFit: 'contain', // Ensure the entire image is visible without cropping
          }} 
        />
        <Typography variant="h4"  component="h1" sx={{ marginTop: '20px' }}>
          {currentBlog.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ marginBottom: '20px' }}>
          {currentBlog.date}
        </Typography>
        <Typography variant="body1">{currentBlog.content}</Typography>
        <Button sx={{ marginTop: '20px' }} variant="contained" color="primary" href="/news-section">
          Back to News
        </Button>
      </Box>
    </Container>
  );
};

export default Blog;
